import * as actions from './actions';
import { LoadingAction } from '../common/loading-action';
import { ErrorAction } from '../common/error-action';
import { Subscription } from '@services/subscription/types/subscription';
import { Stripe, PaymentMethod } from '@stripe/stripe-js';
// import { StripePaymentData } from '../../types/stripe/payment-data';
import { Order } from '../../types/orders/order';
import { Action } from 'redux';
import { Invoice } from '../../../../../services/payment/types/invoice';
import { CustomerMetadata } from '../../../../../services/payment/types/api/customer-metadata';
import { SubscriptionType } from '../../../../../services/subscription/types/subscription-type';

export class CreateSubscription implements LoadingAction {
  readonly type = actions.CREATE_SUBSCRIPTION;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(
    public stripe: Stripe | undefined,
    public paymentMethod: PaymentMethod | undefined,
    public clientId: string,
    public order: Order,
    public customer: CustomerMetadata,
    public subscriptionType: SubscriptionType,
    public currentSubscription?: Subscription,
    public subscriptionId?: string,
    public trialDays?: number,
    public redirectType?: string,
    public id?: string,
    public checkout_source?: string,
    public redirectTo?: string,
    public coupon?: string,
    public tax?: number
  ) {}
}

export class CreateSubscriptionSuccess implements LoadingAction {
  readonly type = actions.CREATE_SUBSCRIPTION_SUCCESS;
  readonly isLoading = false;

  constructor(
    public newSubscription: Subscription,
    public isNew: boolean,
    public subscriptionType: SubscriptionType,
    public order: Order,
    public customer: CustomerMetadata,
    public change?: 'FREQUENCY' | 'DOWNGRADE' | 'UPGRADE' | 'IGNORE',
    public original?: Subscription,
    public redirectType?: string,
    public id?: string,
    public clientId?: string,
    public redirectTo?: string,
    public plan_key?: string,
    public coupon?: string,
    public tax?: number
  ) {}
}

export class CreateMerchSubscriptionSucesss implements LoadingAction {
  readonly type = actions.CREATE_MERCH_SUBSCRIPTION_SUCCESS;
  readonly isLoading = true;
}

export class CancelMerchSubscriptionSuccess implements LoadingAction {
  readonly type = actions.CANCEL_MERCH_SUBSCRIPTION_SUCCESS;
  readonly isLoading = false;
  readonly mainLoader = false;
}

export class CreateSubscriptionError implements ErrorAction {
  readonly type = actions.CREATE_SUBSCRIPTION_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class CancelSubscription implements LoadingAction {
  readonly type = actions.CANCEL_SUBSCRIPTION;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(
    public clientId: string,
    public plan?: SubscriptionType,
    public onSuccess?: () => void
  ) {}
}

export class CancelSubscriptionSuccess implements LoadingAction {
  readonly type = actions.CANCEL_SUBSCRIPTION_SUCCESS;
  readonly isLoading = false;

  constructor(public subscription: Subscription) {}
}

export class CancelSubscriptionError implements ErrorAction {
  readonly type = actions.CANCEL_SUBSCRIPTION_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class GetSubscription implements LoadingAction {
  readonly type = actions.GET_SUBSCRIPTION;
  readonly isLoading = true;
  public mainLoader = true;

  constructor(
    public clientId: string,
    public disableMainLoader?: boolean,
    public retries?: number
  ) {
    this.mainLoader = !disableMainLoader;
  }
}

export class GetSubscriptionSuccess implements LoadingAction {
  readonly type = actions.GET_SUBSCRIPTION_SUCCESS;
  readonly isLoading = false;

  constructor(public subscription: Subscription, public retries: number = 0) {}
}

export class GetSubscriptionError implements ErrorAction {
  readonly type = actions.GET_SUBSCRIPTION_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class GetLabelSubscription implements LoadingAction {
  readonly type = actions.GET_LABEL_SUBSCRIPTION;
  readonly isLoading = true;
  public mainLoader = true;

  constructor(
    public clientId: string,
    public disableMainLoader?: boolean,
    public retries?: number
  ) {
    this.mainLoader = !disableMainLoader;
  }
}

export class GetLabelSubscriptionSuccess implements LoadingAction {
  readonly type = actions.GET_LABEL_SUBSCRIPTION_SUCCESS;
  readonly isLoading = false;

  constructor(public subscription: Subscription, public retries: number = 0) {}
}

export class GetLabelSubscriptionError implements ErrorAction {
  readonly type = actions.GET_LABEL_SUBSCRIPTION_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class GetInvoices implements LoadingAction {
  readonly type = actions.GET_INVOICES;
  readonly isLoading = true;

  constructor(public clientId: string) {}
}

export class GetInvoicesSuccess implements LoadingAction {
  readonly type = actions.GET_INVOICES_SUCCESS;
  readonly isLoading = false;

  constructor(public invoices: Invoice[]) {}
}

export class GetInvoicesError implements ErrorAction {
  readonly type = actions.GET_INVOICES_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class CheckoutInitiated implements Action {
  readonly type = actions.CHECKOUT_INITIATED;
}

export class ClearSubscriptions implements Action {
  readonly type = actions.CLEAR_SUBSCRIPTIONS;
}

export type SubscriptionActions =
  | CreateSubscription
  | CreateSubscriptionSuccess
  | CreateMerchSubscriptionSucesss
  | CancelMerchSubscriptionSuccess
  | CreateSubscriptionError
  | CancelSubscription
  | CancelSubscriptionSuccess
  | CancelSubscriptionError
  | GetSubscription
  | GetSubscriptionSuccess
  | GetSubscriptionError
  | GetLabelSubscription
  | GetLabelSubscriptionSuccess
  | GetLabelSubscriptionError
  | GetInvoices
  | GetInvoicesSuccess
  | GetInvoicesError
  | CheckoutInitiated
  | ClearSubscriptions;
